import * as React from "react"
import Layout from "../views/layouts/layout"
import KnowledgeBaseDefault from "../views/templates/template.knowledgebase.default"
import {graphql} from "gatsby";
import HeadMeta from "../views/components/head/head";
export default function KnowledgeBaseController(props) {
    const article = props.data.article

    return (

        <Layout node={article}>
            {setTemplate(props.data)}
        </Layout>

    )
}

const setTemplate = (data) => {

    const lang = data.article.language.code ?? 'PL'
    const otherPosts = lang === 'EN' ? data.prevnextEN : data.prevnextPL
    const similarPosts = lang === 'EN' ? data.interestedEN : data.interestedPL
    switch(data.article.template.templateName) {
        default:
            return <KnowledgeBaseDefault article={data.article} other={otherPosts} interested={similarPosts}/>
    }
}

export const postQuery = (graphql`
    query KnowledgeBaseById($id: String!) {
        article: wpKnowledgeBase(id: {eq: $id}) {
            id
            title
            excerpt
            template {
                templateName
            }
            language {
                code
            }
		translations {
            uri
            language {
              code
              locale
            }          			    
          }	             
            seo {
                canonical
                metaDescription
                metaTitle
                nofollow
                noindex
                h1
                fastPreviewTitle
                fastPreviewDescription
                seoKeyword
            }
            og {
                title
                description
                image {
                    publicUrl
                    localFile {
                        relativePath
                        publicURL
                        childImageSharp {
                            gatsbyImageData(layout: CONSTRAINED, width: 1200, quality: 80)
                        }
                    }
                }
            }
            ...KnowledgeBaseDefaultInformation
        }
        interestedPL: allWpKnowledgeBase(filter: {id:{ne: $id}, language: {code: {eq: PL}}}, limit: 3){
            nodes{
                id
                title
                uri
                language {
                    code
                }
                ...KnowledgeBaseDefaultInformation
            }
        }
        interestedEN: allWpKnowledgeBase(filter: {id:{ne: $id}, language: {code: {eq: EN}}}, limit: 3){
            nodes{
                id
                title
                uri
                language {
                    code
                }
                ...KnowledgeBaseDefaultInformation
            }
        }
        prevnextPL: allWpKnowledgeBase (filter: {language: {code: {eq: PL}}}){
            edges {
                next {
                    uri
                    link
                    title
                    id
                    language {
                        code
                    }
                }
                previous {
                    uri
                    link
                    title
                    id
                     language {
                        code
                    }
                }
                node {
                    title
                    slug
                    id
                    language {
                        code
                    }
                }
            }
        }
        prevnextEN: allWpKnowledgeBase (filter: {language: {code: {eq: EN}}}){
            edges {
                next {
                    uri
                    link
                    title
                    id
                    language {
                        code
                    }
                }
                previous {
                    uri
                    link
                    title
                    id
                     language {
                        code
                    }
                }
                node {
                    title
                    slug
                    id
                    language {
                        code
                    }
                }
            }
        }
    }
`)

export function Head(props) {
    return props.data.article && <HeadMeta node = {props.data.article}/>
}